import React from "react";

import "features/application/change-email/view.scss";

const ChangeEmailView = () => (
  <section className="application__container">
    <h1 className="application__headline">Change your email</h1>
  </section>
);

export default ChangeEmailView;
